import { SelectProps } from "@bluframe/blublocks"

import Select from "./Select"

export interface Props extends SelectProps {}

export interface ComponentProps extends Props {}

export default Select
